import React from "react";
import {IconProps} from "../../models/interfaces";
import IconUnselectable from "./IconUnselectable";

const IconFitToScreen: React.FC<IconProps> = ({disabled = false, onClick}) => {
	const fill = disabled ? "#82888c" : "#000000";
	const cursor = disabled ? "not-allowed" : "pointer";
	const handleClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => !disabled && onClick(event);

	return (
		<IconUnselectable>
			<svg width={18} height={18} viewBox="0 0 18 18" onClick={handleClick} style={{cursor}}>
				<path fill={fill}
					  d="M2 2h4v1.5H3.5V7H2V2zm10 0h4v5h-1.5V3.5H12V2zM2 11h1.5v3.5H7V16H2v-5zm13.5 3.5H12V16h4v-5h-1.5v3.5z"/>
			</svg>
		</IconUnselectable>
	);
};

export default IconFitToScreen;
